import FormInput, { FormInputProps } from '@/common/Form/FormInput';

import FormWatch from '@/common/Form/FormWatch';
import { InputGroup } from 'react-bootstrap';
import useUuid from '@/hooks/useUuid';

export type FormCheckboxProps = { label?: string; onChange: (checked: boolean) => void } & Omit<
  FormInputProps<'input'>,
  'onChange' | 'type'
>;

const Checkbox = ({ label, ...inputProps }: FormCheckboxProps): JSX.Element => {
  const uuid = useUuid();
  const id = inputProps.id || uuid;
  const handleChange = () => inputProps.onChange?.(!inputProps.checked);

  return (
    <InputGroup style={{ padding: '0.375rem 0.75rem', display: 'flex', flexWrap: 'nowrap', gap: '.5rem' }}>
      <FormInput id={id} {...inputProps} type="checkbox" onChange={handleChange} />
      {label && (
        <label htmlFor={id} style={{ flexGrow: '1' }}>
          {label}
        </label>
      )}
    </InputGroup>
  );
};

const FormCheckbox = ({ name, label }) => {
  return (
    <FormWatch name={name}>
      {([checkBoxName]: number[] = [0], form) => {
        return (
          <Checkbox
            name={name}
            label={label}
            checked={!!checkBoxName}
            onChange={(value) => {
              const valAsNumber = value ? 1 : 0;
              form.setValue(name, valAsNumber);
              return valAsNumber;
            }}
          />
        );
      }}
    </FormWatch>
  );
};

export default FormCheckbox;
